import { useAdsCopilotContext } from '../components/ads-copilot-context-provider';

export function useAdsCopilotLogger() {
  const context = useAdsCopilotContext();
  return context?.logger;
}
